/** @file artBindings: the Art screen's key table (context `art`): arrows, Delete, Enter, KeyM. */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

/** Arrows move the slot selection, Delete clears the slot (after a confirm), Enter picks a PNG, KeyM downloads the mask. */
export const artBindings: Binding[] = [
  { id: 'art.selectLeft', keys: 'ArrowLeft', context: 'art' },
  { id: 'art.selectRight', keys: 'ArrowRight', context: 'art' },
  { id: 'art.selectUp', keys: 'ArrowUp', context: 'art' },
  { id: 'art.selectDown', keys: 'ArrowDown', context: 'art' },
  { id: 'art.clearSlot', keys: 'Delete', context: 'art' },
  { id: 'art.upload', keys: 'Enter', context: 'art' },
  { id: 'art.downloadMask', keys: 'KeyM', context: 'art' },
];
